import { Component, Input } from '@angular/core';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { WorkOrderLine } from '@interfaces/professional-booking';

/** What a booked work-order line holds: its date(s), or its date and time slot (booking plan Phase 5). */
@Component({
    selector: 'app-booking-line-summary',
    templateUrl: './booking-line-summary.component.html',
    styleUrls: ['./booking-line-summary.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, DatePipe, TranslateModule]
})
export class BookingLineSummaryComponent {
    @Input() line: WorkOrderLine;

    /** Booked days as local dates. `booking.dates` are `YYYY-MM-DD`; `new Date('YYYY-MM-DD')` would read them as UTC. */
    get days(): Date[] {
        return (this.line?.booking?.dates ?? []).map((key: string) => {
            const [year, month, day] = key.split('-').map(Number);
            return new Date(year, month - 1, day);
        });
    }

    get isSlot(): boolean {
        return !!this.line?.serviceData?.[0]?.times?.length;
    }

    get isRange(): boolean {
        return !!this.line?.serviceData?.[0]?.endDate && this.days.length > 1;
    }
}
